<template>
	<v-container class="pa-0">
		<v-snackbar
			app
			v-model="show"
			v-if="$page.props.flash.success && show"
			bottom
			right
			:multi-line="false"
			color="black"
			dark
		>
			{{ $page.props.flash.success }}

			<template v-slot:action="{ attrs }">
				<v-btn color="white" text v-bind="attrs" @click="show = false">
					Close
				</v-btn>
			</template>
		</v-snackbar>
		<v-alert
			type="error"
			v-if="
				($page.props.flash.error ||
					Object.keys($page.props.errors).length > 0) &&
				show
			"
			dismissible
			v-model="show"
			prominent
			class="mb-0 ma-3"
		>
			<div
				v-if="$page.props.flash.error"
				class="py-4 text-white text-sm font-medium"
			>
				{{ $page.props.flash.error }}
			</div>
			<div v-else class="py-4 text-white text-sm font-medium">
				<span
					>There are {{ Object.keys($page.props.errors).length }} form
					errors.
				</span>

				<ul>
					<li
						v-for="(error, index) in $page.props.errors"
						:key="index"
					>
						{{ error }}
					</li>
				</ul>
			</div>
		</v-alert>
	</v-container>
</template>

<script>
export default {
	data() {
		return {
			show: true,
		};
	},
	watch: {
		"$page.props.flash": {
			handler() {
				this.show = true;
			},
			deep: true,
		},
	},
};
</script>